import { registerLocaleData } from '@angular/common';
import { Component } from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';

import { NbIconLibraries } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { NbAuthOAuth2JWTToken, NbTokenService } from '@nebular/auth';
import { iif, map, of, switchMap } from 'rxjs';

import { InitUserService } from './@theme/services/init-user.service';
import { Language } from './shared/enums/languages';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'clientsPortal';

  constructor(
    private iconsLibraries: NbIconLibraries,
    private translate: TranslateService,
    private initUserService: InitUserService,
    private tokenService: NbTokenService,
  ) {
    registerLocaleData(localeFr, Language.FRENCH);
    registerLocaleData(localeEn, Language.ENGLISH);

    this.iconsLibraries.registerFontPack('flag-icon');

    this.translate.addLangs(Object.values(Language));
    this.translate.setDefaultLang(Language.ENGLISH);

    // verify that the user is logged-in before retrieving its information
    this.tokenService.get().pipe(
      map((token: NbAuthOAuth2JWTToken) => token.isValid()),
      switchMap((isValid: boolean) => {
        if (isValid) { // JWT auth case
          return this.initUserService.initCurrentUser();
        } else {
          const currentUser = JSON.parse(localStorage.getItem("currentUser"));
          if (currentUser?.user) { // Cookie auth case
            return this.initUserService.initCurrentUser();
          }
          return of(null)
        }
      })
    ).subscribe();
  }

    // ngOnInit(): void {
    //   const currentVersion = environment.appVersion;
    //   const savedVersion = localStorage.getItem('app_version');

    //   if (savedVersion && savedVersion !== currentVersion) {
    //     localStorage.clear();
    //     caches?.keys().then(keys => keys.forEach(k => caches.delete(k)));
    //     location.reload();
    //   }

    //   localStorage.setItem('app_version', currentVersion);
    // }
}
